"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuotoneExclamationCircle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DuotoneExclamationCircle = (props) => {
    return ((0, jsx_runtime_1.jsxs)("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", ...props, children: [(0, jsx_runtime_1.jsx)("circle", { cx: "10", cy: "10", r: "8", fill: "#fff" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z", clipRule: "evenodd" })] }));
};
exports.DuotoneExclamationCircle = DuotoneExclamationCircle;
